// extracted by mini-css-extract-plugin
export default {"container":"Error-module__container-XWcQ5n","icon":"Error-module__icon-RacO_9","red":"Error-module__red-HAancA"};